import { render, staticRenderFns } from "./CodeKeyboard.vue?vue&type=template&id=2d884bd4&scoped=true&"
import script from "./CodeKeyboard.vue?vue&type=script&lang=js&"
export * from "./CodeKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./CodeKeyboard.vue?vue&type=style&index=0&id=2d884bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d884bd4",
  null
  
)

export default component.exports